import { useState } from "react";
import { getApiService } from "../services/api";
import { useAuth } from "../contexts/AuthContext";
import { navigate } from "../hooks/useRoute";
import { AuthCard } from "../components/AuthCard";
import { isValidPhone, isValidPassword } from "../services/format";

// 登录页
export function LoginPage() {
  const { setAuth } = useAuth();
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setError("");
    if (!isValidPhone(phone)) {
      setError("手机号格式错误");
      return;
    }
    if (!password) {
      setError("请输入密码");
      return;
    }
    setBusy(true);
    try {
      const res = await getApiService().login(phone, password);
      if (res.code !== 200 || !res.data?.user) {
        setError(res.message ?? "登录失败");
        return;
      }
      setAuth(res.data.user.token, res.data.user.phone);
      navigate("/home");
    } catch {
      setError("网络错误，请稍后重试");
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthCard title="登录">
      <div className="mb-3">
        <label className="label">手机号</label>
        <div className="flex items-center gap-2">
          <span className="input" style={{ width: 64, textAlign: "center", flexShrink: 0 }}>
            +86
          </span>
          <input
            className="input"
            type="tel"
            maxLength={11}
            inputMode="numeric"
            placeholder="请输入手机号"
            value={phone}
            onChange={(e) => setPhone(e.target.value.replace(/\D/g, ""))}
          />
        </div>
      </div>

      <div className="mb-2">
        <label className="label">密码</label>
        <input
          className="input"
          type="password"
          placeholder="请输入密码"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && submit()}
        />
      </div>

      <div className="flex justify-end mb-3">
        <button className="flat text-13px" onClick={() => navigate("/forgot")}>
          忘记密码？
        </button>
      </div>

      {error && <div className="down text-13px mb-3">{error}</div>}

      <button className="btn btn-primary w-full py-2.5" disabled={busy} onClick={submit}>
        登录
      </button>

      <div className="text-center mt-4 text-13px flat">
        没有账号？{" "}
        <button className="up" onClick={() => navigate("/register")}>
          立即注册
        </button>
      </div>
    </AuthCard>
  );
}
